// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".confirm-cancel-modal .modal-content {\n  width: 100%; }\n\n.confirm-cancel-modal .cancel-btn {\n  border: 1px solid #b9b8b8;\n  color: #737373;\n  border-radius: 4px;\n  padding: 2px 10px; }\n\n.confirm-cancel-modal .confirm-btn {\n  margin-left: 2%;\n  padding: 2px 10px;\n  color: white;\n  background: #737373;\n  border-radius: 4px; }\n\n.confirm-cancel-modal .modal-footer {\n  border-top: none; }\n", ""]);
// Exports
module.exports = exports;
